import Link from 'next/link';
import { cn } from 'common/utils';

interface NavLinkType {
  href: string;
  children: React.ReactNode;
  isActive?: boolean;
  className?: string;
  isExternal?: boolean;
}

const NavLink = ({
  href,
  children,
  isActive = false,
  className = '',
  isExternal = false,
}: NavLinkType) => {
  return (
    <Link
      href={href}
      target={isExternal ? '_blank' : '_self'}
      className={cn(
        `text-base font-medium text-pp-text-secondary transition-colors duration-200 hover:text-pp-text-primary`,
        className ?? '',
        {
          'font-bold text-pp-text-primary': isActive,
        },
      )}
    >
      {children}
    </Link>
  );
};

export default NavLink;
